export const BAR_SIZE = 6
export const NAV_PADDING = 24
export const NAV_PADDING_MOBILE = 20
